<div #blockBody class="external-sidebar" class="{{ displayMode }}">
	<div class="sidebar-header" *ngIf="!gamesLoading && !gamesError && configurationObject.sports.length > 1">
		<div class="sidebar-title">
			<!-- <div class="bookie-icon" *ngIf="configurationObject.bookmakerTheme"></div> -->
			{{ localisationService.localeTerm('sidebar_title', 'all-caps') }}
		</div>
		<div class="sport-dropdown" *ngIf="sidebarSports.length > 1">
			<select [(ngModel)]="selectedSport" (change)="handleSportChange()">
				<option value="all" *ngIf="configurationObject.showAllOption">ALL SPORTS</option>
				<option *ngFor="let sport of sidebarSportOptions" 
					[value]="sport | lowercase">
					{{ sport | uppercase }}
				</option>
			</select>
		</div>

		<!-- Replaces dropdown so that live toggle stays on right edge -->
		<div class="dropdown-placeholder" *ngIf="sidebarSports.length <= 1"></div>

		<div class="live-toggle" *ngIf="configurationObject.showLiveToggle && anyLiveMatches()">
			<div class="toggle-option" [class.selected-option]="liveToggleState === 'live'" (click)="setLiveToggleState('live')">
				Live
			</div>
			<div class="toggle-option" [class.selected-option]="liveToggleState === 'next'" (click)="setLiveToggleState('next')">
				<span class="compact-only">Next</span>
				<span class="large-only">Next to Go</span>
			</div>
		</div>
	</div>
	<div class="sidebar-loading" *ngIf="gamesLoading && !gamesError">
		Loading...
	</div>
	<div class="sidebar-loading no-matches" *ngIf="!gamesLoading && !gamesError && sidebarSports.length === 1 && matches.length === 0">
		No matches available right now
	</div>
	<div class="sidebar-loading" *ngIf="gamesError">
		<span class="error-main">
			<span>
				We are having trouble loading {{ localisationService.localeTerm('fixture', '') }} data
			</span>
		</span>

		<span>
			Please
			<span class="retry-link"
				(click)="reloadGames()">
				try again
			</span>
		</span>
	</div>
	<div class="sidebar-games" *ngIf="!gamesLoading && !gamesError">
		<a *ngFor="let match of displayedMatches"
			[href]="generalService.getMatchLink(match.MatchData.SIMatchID)"
			class="game-link">
			<app-match-tile
				[match]="match"
			></app-match-tile>
		</a>
	</div>
</div>
